import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    inject,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
    CasinoIFrameOverlayService,
    CasinoLobbyService,
    CasinoManager,
    CasinoStylesService,
    ConfigProviderService,
    GameDataManager,
    GameManagerService,
    PromotedGamesService,
    RecentGamesService,
    UnfinishedGamesService,
} from '@casinocore/platform/core';
import { DeviceService, UserService } from '@frontend/vanilla/core';
import {
    NguCarousel,
    NguCarouselConfig,
    NguCarouselDefDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguCarouselStore,
    NguItemComponent,
} from '@ngu/carousel';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';

import { CategoryiconSubtitleComponent } from '../categoryicon-subtitle/categoryicon-subtitle.component';
import { FeatureGridComponent } from '../feature-grid/feature-grid.component';
import { GameLobbyComponent } from '../gamelobby/gamelobby.component';
import { SignPostingComponent } from '../sign-posting/sign-posting.component';

export class RgGameModel {
    gameId: string;
    sticker: string;
}

export class RGGame {
    GameId: string;
    isRecentlyPlayed: boolean;
    isPromoted: boolean;
    sticker: string;
    fromCasino: boolean = true;
    constructor(gameId: string, isPromoted: boolean, isRecentlyPlayed: boolean, fromCasino: boolean) {
        this.GameId = gameId;
        this.isRecentlyPlayed = isRecentlyPlayed;
        this.isPromoted = isPromoted;
        this.fromCasino = fromCasino;
    }
}

@Component({
    selector: 'cc-rp-gyml',
    templateUrl: 'recentlyplayed-gyml.component.html',
    imports: [
        NgIf,
        NgClass,
        CategoryiconSubtitleComponent,
        NgFor,
        GameLobbyComponent,
        NgStyle,
        SignPostingComponent,
        FeatureGridComponent,
        NguCarouselNextDirective,
        NguCarouselPrevDirective,
        NguCarouselDefDirective,
        NguItemComponent,
        NguCarousel,
    ],
})
export class RecentlyPlayedandGymlComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() lobbyType: string;
    @Input() gameContainer: string;
    @ViewChild('recentGYMLCarousel') recentGYMLCarousel: NguCarousel<any>;
    @Input() categoryId: string = '';
    recentCategory: any;
    gymlCategory: any;
    recentlyandGymlGames: any = [];
    baseGameCount: number;
    recentStartIndex: number = 0;
    maxScrollPosition: number;
    staticGYML: boolean;
    unfinishedGames: any = [];
    Games: any[] = [];
    isCombinedCategories: boolean = false;
    subcategory: any;
    onlyRecentGames: any[] = [];
    onlyRecentGamesStrings: any[] = [];
    onlyGYMLGamesStrings: any[] = [];
    onlyGYMLGames: any[] = [];
    youMightLikeMessage: any;
    gymlGames: any = [];
    recentGames: any = [];
    gymlGameStrings: any = [];
    isTouch: any;
    unfinishedRPANDGYMLGameIds: RGGame[] = [];
    unfinishedRPANDGYMLGames: any = [];
    recentGamesCount: number = 0;
    subcategoryNew: any;
    isCombinedCategoriesNew: boolean = false;
    recentsObs: any;
    unfinishedObv: any;
    categoryLookupObv: any;
    defaultCategoryLookupObv: any;
    lobbyObs: any;
    isUkHeading: boolean;
    alignIconRight: boolean;
    lang: string;
    topValueForGYML: any;
    isCrossSaleIOS: boolean;
    isSignPosting: boolean;
    featureConfig: any;
    globalConfig: any;
    casinoConfig: any;
    isClientConfigLoaded: any;
    promotedGamesText: string;
    isPreButtonVisible: boolean;
    isGamesWidgetPreButtonVisible: boolean;
    isNextButtonVisible: boolean;
    recentTitle: string;
    clientConfigLoadSubscription: Subscription;
    bingoRecentGames: any = [];
    trackingClass: string = '';
    recentlyPlayedGames: any = [];
    public carouselConfig: NguCarouselConfig;
    promotedFeedSub: Subscription;
    recentGamesSubscription: Subscription;
    newFeatureGridArr: any[] = [];
    categoryObj: any;
    gymlCategoryRef: any;
    readonly showFeatureGrid = signal(true);

    enableEpcotSubNavigation: boolean;

    private readonly casinoLobbyService = inject(CasinoLobbyService);
    private readonly gameDataManager = inject(GameDataManager);
    private readonly recentGameService = inject(RecentGamesService);
    private readonly configProviderService = inject(ConfigProviderService);
    private readonly elementRef = inject(ElementRef);
    private readonly unfinishedGameService = inject(UnfinishedGamesService);
    private readonly casinoManager = inject(CasinoManager);
    private readonly casinoIFrameOverlayService = inject(CasinoIFrameOverlayService);
    private readonly deviceService = inject(DeviceService);
    private readonly user = inject(UserService);
    private readonly promotedGamesService = inject(PromotedGamesService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly casinoStyles = inject(CasinoStylesService);
    private readonly gameManagerService = inject(GameManagerService);
    private destroyRef = inject(DestroyRef);

    constructor() {
        this.carouselConfig = {
            grid: { xs: 3, sm: 6, md: 6, lg: 6, all: 0 },
            slide: 6,
            speed: 400,
            // interval: 10000,
            point: {
                visible: false,
            },
            loop: false,
            touch: false,
        };
    }

    ngOnInit() {
        this.isTouch = this.casinoManager.isTouch();
        this.isClientConfigLoaded = true;
        this.setRpGyml();
        this.isPreButtonVisible = true;
        const subnavConfig: any = this.configProviderService.provideSubNavigationConfig();
        this.enableEpcotSubNavigation = subnavConfig.enableEpcotSubNavigation;
    }

    ngOnDestroy() {
        if (this.clientConfigLoadSubscription) {
            this.clientConfigLoadSubscription.unsubscribe();
        }
        if (this.promotedFeedSub) {
            this.promotedFeedSub.unsubscribe();
        }
        if (this.recentGamesSubscription) {
            this.recentGamesSubscription.unsubscribe();
        }
        if (this.unfinishedObv) {
            this.unfinishedObv.unsubscribe();
        }
    }
    setRpGyml() {
        if (this.isClientConfigLoaded) {
            this.featureConfig = this.configProviderService.provideFeaturesConfig();
            this.globalConfig = this.configProviderService.provideGlobalConfig();
            this.casinoConfig = this.configProviderService.provideCasinoConfig();
            this.youMightLikeMessage = this.globalConfig.messages['LobbyGamesYouMightLike']
                ? this.globalConfig.messages['LobbyGamesYouMightLike']
                : this.globalConfig.messages['GamesYouMightLike'];

            this.gymlCategory = this.casinoLobbyService.getCategoryInfo(this.lobbyType, 'LMC_GYML');
            this.promotedGamesText = this.globalConfig.lobbyConfigurations['PromotedGamesCategoryname'];
            // if (this.gymlCategory) {
            //     this.gymlCategory.rowCount = '-1';
            // }

            this.recentCategory = this.casinoLobbyService.getCategoryInfo(this.lobbyType, 'recentgames');
            this.setGamesOnInit();
            this.promotedFeedSub = this.promotedGamesService.promotedFeedObservable
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((games: any) => {
                    if (games) {
                        this.setUnfinishedRPAndGYML(
                            this.promotedGamesService.getPromotedGames(),
                            this.unfinishedGameService.getUnfinishedGames(),
                            this.recentGameService.getrecentGames(),
                            this.bingoRecentGames,
                            this.getGymlGameIds(this.casinoLobbyService.getCategoryInfo(this.lobbyType, 'LMC_GYML')),
                        );
                    }
                });
            this.recentGamesSubscription = this.recentGameService.recentGamesFeedObservable
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((e: any) => {
                    if (this.recentCategory && e) {
                        this.setUnfinishedRPAndGYML(
                            this.promotedGamesService.getPromotedGames(),
                            this.unfinishedGameService.getUnfinishedGames(),
                            this.recentGameService.getrecentGames(),
                            this.bingoRecentGames,
                            this.getGymlGameIds(this.casinoLobbyService.getCategoryInfo(this.lobbyType, 'LMC_GYML')),
                        );
                    }
                });
            this.alignIconRight = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, this.featureConfig.alignIconRight);
            this.unfinishedObv = this.unfinishedGameService.unfinishedFeedObservable
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((response) => {
                    if (response) {
                        this.unfinishedGames = response;
                        this.setUnfinishedRPAndGYML(
                            this.promotedGamesService.getPromotedGames(),
                            response,
                            this.recentGameService.getrecentGames(),
                            this.bingoRecentGames,
                            this.getGymlGameIds(this.casinoLobbyService.getCategoryInfo(this.lobbyType, 'LMC_GYML')),
                        );
                    }
                });

            if (this.recentCategory && this.recentCategory.categoryInfo) this.recentCategory.categoryInfo.categoryIndex = 1;
            if (this.gymlCategory && this.gymlCategory.categoryInfo) this.gymlCategory.categoryInfo.categoryIndex = 1;
            if (this.subcategory && this.subcategory.categoryInfo) this.subcategory.categoryInfo.categoryIndex = 1;
            this.isUkHeading = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, this.featureConfig.isUkHeading);
            this.isCrossSaleIOS = this.casinoIFrameOverlayService.isOverLayOnAProduct() && this.deviceService.isiOS;
            this.isSignPosting = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, this.featureConfig.enableSignpostingSticker);
            this.trackingClass = 'track_' + this.categoryId;
            //this.categoryObj = {...this.subcategory?.categoryInfo };
            this.categoryObj = Object.assign({}, this.subcategory?.categoryInfo, true);
            this.categoryObj.rowCount = '-1';
        }
    }

    setGamesOnInit() {
        const unfinishedGames = this.unfinishedGameService.getUnfinishedGames();
        const recentGames = this.recentGameService.getrecentGames();
        const promotedGames = this.promotedGamesService.getPromotedGames();
        this.gymlCategory = this.casinoLobbyService.getCategoryInfo(this.lobbyType, 'LMC_GYML');
        let gymlGames: any;
        if (this.gymlCategory) {
            //this.gymlCategory.rowCount = '-1';
            gymlGames = this.getGymlGameIds(this.gymlCategory);
        }

        this.setUnfinishedRPAndGYML(promotedGames, unfinishedGames, recentGames, this.bingoRecentGames, gymlGames);
    }

    getGymlGameIds(gymlCategory: any): RgGameModel[] {
        const gymlGames: RgGameModel[] = [];
        if (gymlCategory && gymlCategory.categoryInfo && gymlCategory.categoryInfo.gamelist && gymlCategory.categoryInfo.gamelist.length > 0) {
            for (let i = 0; i < gymlCategory.categoryInfo.gamelist.length; i++) {
                const gameModel: RgGameModel = new RgGameModel();
                gameModel.gameId = gymlCategory.categoryInfo.gamelist[i].game;
                if (gymlCategory.categoryInfo.gamelist[i].sticker) {
                    gameModel.sticker = gymlCategory.categoryInfo.gamelist[i].sticker;
                }
                gymlGames.push(gameModel);
            }
        }
        return gymlGames;
    }

    setUnfinishedRPAndGYML(
        promotedGames: string[],
        unfinishedGames: string[],
        recentGames: string[],
        bingoRecentGames: string[],
        gymlGames: RgGameModel[],
    ) {
        if (!unfinishedGames) {
            unfinishedGames = [];
        }
        if (!recentGames) {
            recentGames = [];
        }
        if (!bingoRecentGames) {
            bingoRecentGames = [];
        }
        if (!gymlGames) {
            gymlGames = [];
        }
        if (!promotedGames) {
            promotedGames = [];
        }
        const unfinishedRecentArray: RGGame[] = this.concatUnfinishedAndRecentGames(promotedGames, unfinishedGames, recentGames, bingoRecentGames);
        if (!this.user.isAuthenticated) {
            unfinishedRecentArray.forEach((item: any) => {
                item.isRecentlyPlayed = false;
            });
        }
        this.unfinishedRPANDGYMLGameIds = this.concatUnfinishedRecentANDGYMLGames(unfinishedRecentArray, gymlGames);
        this.processRecentGYMLGames();
    }

    concatUnfinishedAndRecentGames(promotedGames: string[], unfinishedGames: string[], recentGames: string[], bingoRecentGames: string[]): RGGame[] {
        const unfinishedRecentArray: RGGame[] = [];

        for (let i = 0; i < unfinishedGames.length; i++) {
            unfinishedRecentArray.push(new RGGame(unfinishedGames[i], false, true, true));
        }
        for (let i = 0; i < recentGames.length; i++) {
            const filteredRecentGame: any = unfinishedRecentArray.filter((unfinished) => {
                return unfinished.GameId === recentGames[i];
            });
            if (!(filteredRecentGame.length > 0)) {
                const recentGame: RGGame = new RGGame(recentGames[i], false, true, true);
                unfinishedRecentArray.push(recentGame);
            }
        }
        for (let i = 0; i < promotedGames.length; i++) {
            const filteredPromotedGame: any = unfinishedRecentArray.filter((promotedGame) => {
                return promotedGame.GameId === promotedGames[i];
            });
            if (!(filteredPromotedGame.length > 0)) {
                const promotedGame: RGGame = new RGGame(promotedGames[i], true, true, true);
                unfinishedRecentArray.push(promotedGame);
            }
        }

        for (let i = 0; i < bingoRecentGames.length; i++) {
            const filteredBingoRecentGame: any = unfinishedRecentArray.filter((unfinishedRecentGame) => {
                return unfinishedRecentGame.GameId === bingoRecentGames[i];
            });
            if (!(filteredBingoRecentGame.length > 0)) {
                const recentGame: RGGame = new RGGame(bingoRecentGames[i], false, true, false);
                unfinishedRecentArray.push(recentGame);
            }
        }
        if (
            unfinishedRecentArray.length == promotedGames.length &&
            unfinishedGames.length == 0 &&
            recentGames.length == 0 &&
            bingoRecentGames.length == 0
        ) {
            this.recentTitle = this.promotedGamesText;
        } else {
            if (
                this.recentCategory &&
                this.recentCategory.categoryInfo &&
                this.recentCategory.categoryInfo.sitecoreData &&
                this.recentCategory.categoryInfo.sitecoreData.title
            ) {
                this.recentTitle = this.recentCategory.categoryInfo.sitecoreData.title;
            }
        }
        return unfinishedRecentArray;
    }

    concatUnfinishedRecentANDGYMLGames(unfinishedRecentGames: RGGame[], gymlGames: RgGameModel[]): RGGame[] {
        const unfinishedRecentGYMLArray: RGGame[] = unfinishedRecentGames;
        for (let i = 0; i < gymlGames.length; i++) {
            const gymlGameInRecentArray: any = unfinishedRecentGYMLArray.find((a) => a.GameId === gymlGames[i].gameId);
            if (!gymlGameInRecentArray) {
                const gymlItem: RGGame = new RGGame(gymlGames[i].gameId, false, false, true);
                gymlItem.sticker = gymlGames[i].sticker;
                unfinishedRecentGYMLArray.push(gymlItem);
            }
        }
        return unfinishedRecentGYMLArray;
    }

    processRecentGYMLGames() {
        this.sliceGYMLLimitAndSetBaseGameCount();
        this.setGames();
        this.setIsCombinedCategories();
        this.updateGYMLCategoryRowCount();
    }

    sliceGYMLLimitAndSetBaseGameCount() {
        const unfinishedOrRecentGames = this.unfinishedRPANDGYMLGameIds.filter((game: any) => game.isRecentlyPlayed);
        if (unfinishedOrRecentGames) {
            this.recentGamesCount = unfinishedOrRecentGames.length;
            this.recentStartIndex = 0;
        }

        let gymlGames = this.unfinishedRPANDGYMLGameIds.filter((game: any) => !game.isRecentlyPlayed);
        gymlGames = gymlGames.slice(0, this.casinoConfig.gymlLimit);
        this.unfinishedRPANDGYMLGameIds = [];
        this.unfinishedRPANDGYMLGameIds = this.unfinishedRPANDGYMLGameIds.concat(unfinishedOrRecentGames);
        this.unfinishedRPANDGYMLGameIds = this.unfinishedRPANDGYMLGameIds.concat(gymlGames);
    }

    setGames() {
        if (this.unfinishedRPANDGYMLGameIds && this.unfinishedRPANDGYMLGameIds.length > 0) {
            const gamesModel: any[] = [];
            let GameModelItem: any;
            for (let i = 0; i < this.unfinishedRPANDGYMLGameIds.length; i++) {
                const gameInfo = this.gameManagerService.getGameInfo(this.unfinishedRPANDGYMLGameIds[i].GameId);
                if (!gameInfo) continue;
                if (gameInfo) {
                    const gameName = gameInfo.name;
                    const provider = gameInfo.provider;
                    const ownerId = gameInfo.ownerId;
                    GameModelItem = {
                        game: this.unfinishedRPANDGYMLGameIds[i].GameId,
                        name: gameName,
                        provider: provider,
                        ownerId: ownerId,
                        icon: '1',
                        isRecentlyPlayed: this.unfinishedRPANDGYMLGameIds[i].isRecentlyPlayed,
                        sticker: this.unfinishedRPANDGYMLGameIds[i].sticker,
                        fromCasino: this.unfinishedRPANDGYMLGameIds[i].fromCasino,
                        gameContainer: this.gameContainer,
                        isPromoted: this.unfinishedRPANDGYMLGameIds[i].isPromoted,
                    };
                } else if (!this.unfinishedRPANDGYMLGameIds[i].fromCasino) {
                    GameModelItem = {
                        game: this.unfinishedRPANDGYMLGameIds[i].GameId,
                        icon: '1',
                        isRecentlyPlayed: this.unfinishedRPANDGYMLGameIds[i].isRecentlyPlayed,
                        sticker: this.unfinishedRPANDGYMLGameIds[i].sticker,
                        fromCasino: this.unfinishedRPANDGYMLGameIds[i].fromCasino,
                        gameContainer: this.gameContainer,
                        lobbyType: this.lobbyType,
                    };
                }
                if (GameModelItem) {
                    gamesModel.push(GameModelItem);
                }
            }

            this.setDefaultLMTGameIcons(gamesModel);
        } else if (this.unfinishedRPANDGYMLGameIds && this.unfinishedRPANDGYMLGameIds.length === 0) {
            this.Games = [];
            this.unfinishedRPANDGYMLGames = [];
        }
    }

    setDefaultLMTGameIcons(gamesModellist: any[]) {
        this.Games = [];
        this.unfinishedRPANDGYMLGames = [];
        let starttileBgMode: boolean = false;
        const disabledGames: any = this.casinoLobbyService.getDisabledGames();
        const currentWidth = this.casinoManager.getCurrentWidth();
        if (gamesModellist && gamesModellist.length > 0) {
            for (let i = 0; i < gamesModellist.length; i++) {
                const gameModelItem: any = gamesModellist[i];
                const filteredGame: any = disabledGames.filter((disabledGame: any) => disabledGame === gameModelItem.game);
                if (!(filteredGame && filteredGame.length > 0)) {
                    const gamelobbyModel: any = this.gameDataManager.setGameLobbyModel(gameModelItem, this.isTouch);
                    gamelobbyModel.isRecentlyPlayed = gamesModellist[i].isRecentlyPlayed;
                    gamelobbyModel.isUnfinished = this.getUnfinishedStatus(gamelobbyModel.gameId);
                    gamelobbyModel.fromCasino = gamesModellist[i].fromCasino;
                    gamelobbyModel.infoIconClass = this.casinoManager.assignGameClass(currentWidth, '1');
                    gamelobbyModel.lobbyType = this.lobbyType;
                    gamelobbyModel.gameContainer = this.gameContainer;
                    gamelobbyModel.isPromoted = gamesModellist[i].isPromoted;
                    gamelobbyModel.provider = gamesModellist[i].provider;
                    gamelobbyModel.ownerId = gamesModellist[i].ownerId;
                    gamelobbyModel.trackCategory = this.categoryId;
                    if (this.subcategory && this.subcategory.categoryInfo) {
                        gamelobbyModel.gameTileBorderRadius = this.casinoStyles.getBorderRadius(this.subcategory.categoryInfo);
                        gamelobbyModel.gameTileDropShadow = this.casinoStyles.getDropShadow(this.subcategory.categoryInfo);
                        gamelobbyModel.bgTileMode = this.subcategory.categoryInfo.isIconSevenCategory
                            ? starttileBgMode
                                ? starttileBgMode
                                : false
                            : false;
                    }
                    // to avoid duplicate insertion, checking if gameId already exists or not
                    if (!this.Games.find((x) => x.gameId === gamelobbyModel.gameId)) {
                        this.Games.push(gamelobbyModel);
                    }
                }
                starttileBgMode = !starttileBgMode;
            }
            this.unfinishedRPANDGYMLGames = this.Games;
            const promotedGames = this.unfinishedRPANDGYMLGames.filter((game: any) => game.isPromoted);
            const nonPromotedGames = this.unfinishedRPANDGYMLGames.filter((game: any) => !game.isPromoted);
            this.unfinishedRPANDGYMLGames = [];
            this.unfinishedRPANDGYMLGames = this.unfinishedRPANDGYMLGames.concat(promotedGames);
            this.unfinishedRPANDGYMLGames = this.unfinishedRPANDGYMLGames.concat(nonPromotedGames);

            // let iconType = '1';
            // let currentWidth = this.casinoManager.getCurrentWidth();
            // this.unfinishedRPANDGYMLGames.forEach((game: any) => {
            //     game.infoIconClass = this.casinoManager.assignGameClass(currentWidth, iconType);
            // });
            let filteredgames: any = [];
            const recentGamesModel: any = gamesModellist.filter((gameModel) => gameModel.isRecentlyPlayed);
            filteredgames = this.removeDuplicategames(recentGamesModel);
            if (this.recentCategory) {
                this.recentCategory.categoryInfo.gamelist = filteredgames;
            }
            this.isPreButtonVisible = true;
            if (this.unfinishedRPANDGYMLGames.length > 6) {
                this.isNextButtonVisible = false;
            } else {
                this.isNextButtonVisible = true;
            }
        }
    }

    getUnfinishedStatus(gameId: string): boolean {
        const unfinishedGamesArray: any = this.unfinishedGameService.getUnfinishedGames();
        return unfinishedGamesArray.indexOf(gameId) != -1;
    }
    setIsCombinedCategories() {
        this.showFeatureGrid.set(false);
        const recentGamesCountLimit = this.casinoConfig.recentGamesCountLimit;
        if (this.unfinishedRPANDGYMLGames && this.unfinishedRPANDGYMLGames.length > 0) {
            const recentGames = this.unfinishedRPANDGYMLGames.filter((game: any) => game.isRecentlyPlayed);
            const gymlGames = this.unfinishedRPANDGYMLGames.filter((game: any) => !game.isRecentlyPlayed);
            if (!this.evaluateIsCombined(recentGames, gymlGames)) {
                this.isCombinedCategories = false;

                if (recentGames.length === 0 && this.gymlCategory && gymlGames.length > 0) {
                    this.subcategory = this.gymlCategory;
                    this.unfinishedRPANDGYMLGames = this.unfinishedRPANDGYMLGames.filter((game: any) => !game.isRecentlyPlayed);
                    this.Games = this.removeDuplicategames(this.unfinishedRPANDGYMLGames);
                } else if ((recentGames.length >= recentGamesCountLimit || recentGames.length > 0) && this.recentCategory) {
                    this.subcategory = this.recentCategory;
                    this.unfinishedRPANDGYMLGames = this.unfinishedRPANDGYMLGames.filter((game: any) => game.isRecentlyPlayed);
                    this.Games = this.removeDuplicategames(this.unfinishedRPANDGYMLGames);
                }
                this.newFeatureGridArr = [];
                for (let i = 0; i < this.Games.length; i++) {
                    this.newFeatureGridArr.push({
                        games: [this.Games[i]],
                        maxRowSpan: this.Games[i].rowSpan,
                        maxColSpan: this.Games[i].colSpan,
                    });
                }
            } else {
                this.isCombinedCategories = true;
            }
        }
        this.cdr.detectChanges();
        this.showFeatureGrid.set(true);
    }

    evaluateIsCombined(recentGames: any, gymlGames: any): boolean {
        const recentGamesCountLimit = this.casinoConfig.recentGamesCountLimit;
        if (!recentGames || (recentGames && recentGames.length === 0)) {
            return false;
        }
        if (!gymlGames || (gymlGames && gymlGames.length === 0)) {
            return false;
        }
        if (recentGames && recentGames.length > 0 && recentGames.length > recentGamesCountLimit) {
            return false;
        }
        return true;
    }

    ngAfterViewInit() {
        const gym = document.getElementById('gymlId');
        if (gym) {
            this.maxScrollPosition = gym.offsetLeft;
        }
    }

    configureGYMLScenarios(recentGames: any) {
        const recentGamesCountLimit = this.casinoConfig.recentGamesCountLimit;
        this.subcategory = undefined;
        if (recentGames.length === 0 || recentGames.length >= recentGamesCountLimit) {
            this.isCombinedCategories = false;
        } else {
            this.isCombinedCategories = true;
        }
        if (
            (recentGames.length > 0 && !this.gymlCategory) ||
            (this.gymlCategory && this.gymlCategory.gamesModel && this.gymlCategory.gamesModel.length === 0)
        ) {
            this.isCombinedCategories = false;
        }

        if (!this.isCombinedCategories && recentGames.length === 0 && this.gymlCategory) {
            this.subcategory = this.gymlCategory;
        } else if (
            (!this.isCombinedCategories && recentGames.length >= recentGamesCountLimit && this.recentCategory) ||
            (recentGames.length > 0 && this.recentCategory && !this.gymlCategory)
        ) {
            this.subcategory = this.recentCategory;
        }
    }

    setSubCategoryStyle() {
        if (this.isTouch) {
            return 'scrollable-games';
        }
        return 'unscrollable-games';
    }

    loadNextGamesSet() {
        if (this.subcategory && this.subcategory.games && this.subcategory.games.length > 0) {
        }
    }

    scrollGYML() {
        if (this.elementRef.nativeElement.getElementsByClassName('scrollable-games')[0].scrollLeft >= this.maxScrollPosition) {
            this.staticGYML = true;
            setTimeout(() => {
                const ele = document.getElementById('sticky-container');
                ele!.setAttribute('position', 'relative');
            }, 500);
        } else if (this.elementRef.nativeElement.getElementsByClassName('scrollable-games')[0].scrollLeft < this.maxScrollPosition) {
            this.staticGYML = false;
        }
    }

    onmoveFn(event: NguCarouselStore) {
        this.recentStartIndex = event.currentSlide;
        this.isPreButtonVisible = event.isFirst;
        this.isNextButtonVisible = event.isLast;
    }

    removeDuplicategames(recentGamesModel: any[]): any {
        let filteredgames: any = [];
        if (recentGamesModel && recentGamesModel.length > 0) {
            // deleting duplicate game ids if any
            const uniqueValuesSet = new Set();
            filteredgames = recentGamesModel.filter((obj) => {
                const isPresentInSet = uniqueValuesSet.has(obj.game != undefined ? obj.game : obj.gameId);
                uniqueValuesSet.add(obj.game != undefined ? obj.game : obj.gameId);
                return !isPresentInSet;
            });
        }
        return filteredgames;
    }
    updateGYMLCategoryRowCount() {
        if (this.gymlCategory) {
            this.gymlCategoryRef = cloneDeep(this.gymlCategory);
            //    this.gymlCategoryRef = JSON.parse(JSON.stringify(this.gymlCategory));
            if (this.gymlCategoryRef.categoryInfo) this.gymlCategoryRef.categoryInfo.rowCount = '-1';
        }
    }

    getRPGymlTrackingId(game: any): string {
        const defaultTracking: string = 'gameIdentifier_';
        if (game?.fromCasino) {
            if (game?.isUnfinished) {
                return defaultTracking + 'unfinished';
            } else if (game?.isPromoted) {
                return defaultTracking + 'promoted';
            } else if (game?.isRecentlyPlayed) {
                return defaultTracking + 'recentlyplayed';
            } else return defaultTracking + 'gymlgames';
        }
        return defaultTracking + 'bingogames';
    }
}
